import { h, Component } from 'preact';
import Loader from 'components/shared/dynamicPageLoader/loader';
import { joinClasses, isEmptyObject } from 'utils/utils';

import s from 'components/shared/dynamicPageLoader/dynamicPageLoader.sss';

const pageTypesCache = {};

export default class DynamicPageLoader extends Component {
	constructor(props) {
		super(props);

		this.activeRequest = 0;
		this.componentKey = 1;
		this.state.components = [];
		this.usePage(props.page, props.data, props.props);
	}

	componentWillReceiveProps(nextProps) {
		if (!this.pagesEqual(nextProps.page, this.props.page)) {
			this.usePage(nextProps.page, nextProps.data, nextProps.props);
		} else {
			this.updateCurrentPageProps(nextProps.props);
		}
	}

	componentWillUnmount() {
		this.unmounted = true;
	}

	pagesEqual(page1, page2) {
		if (page1 === page2) {
			return true;
		}
		if (!page1 || !page2) {
			return false;
		}
		if (page1.page && page2.page && page1.page === page2.page) {
			return true;
		}
		return false;
	}

	updateActiveComponent(component, data, props) {
		let key = this.componentKey++;
		let components = this.state.components;
		this.state.components.forEach(el => {
			if (el.removeTimer) {
				return;
			}
			// How should removeDelay be specified ?
			let delay = isNaN(+el.removeDelay) ? 500 : +el.removeDelay;
			el.removeTimer = setTimeout(() => {
				if (this.unmounted) {
					return;
				}
				this.setState({ components: this.state.components.filter(e => e !== el) });
			}, delay);
		});
		components = components.concat({
			component,
			key,
			data,
			props
		});
		this.setState({ components, activeKey: key });
	}

	updateCurrentPageProps(props) {
		this.activeProps = props;
		if (!this.state.components.length) {
			return;
		}
		let currentComponent = this.state.components[this.state.components.length - 1];
		currentComponent.props = props;
	}

	async usePage(page, data, props) {
		if (!page || !page.getter) {
			return;
		}
		if (typeof page.getter !== 'function') {
			return this.updateActiveComponent(page.getter, data, props);
		}
		if (pageTypesCache[page.id]) {
			return this.updateActiveComponent(pageTypesCache[page.id], data, props);
		}
		let activeRequest = ++this.activeRequest;
		this.activeProps = props;
		this.updateActiveComponent(page.loader || Loader, { loader: true });
		// await new Promise(r => setTimeout(r, 10000));
		// return;
		const component = await page.getter();

		try {
			if (!isEmptyObject(component) && typeof this.props.onLoad === 'function') {
				this.props.onLoad();
			}
		} catch (e) {}

		pageTypesCache[page.id] = component;
		if (this.activeRequest !== activeRequest) {
			return;
		}
		this.updateActiveComponent(component, data, this.activeProps);
	}

	render(props, state) {
		return (
			<div class={joinClasses(s.container, props.containerClass)}>
				{state.components.map(el => {
					const Page = el.component.default || el.component;
					return (
						<div
							class={joinClasses(s.component, state.activeKey === el.key && s.active, props.class, el.data?.loader && s.loader)}
							key={el.key}
						>
							<Page page={el.data} {...el.props} />
						</div>
					);
				})}
			</div>
		);
	}
}
